var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        "close-on-click-modal": false,
        title: this.$t("CargoMsg.Cargo_ModifyWriteOffRecord"),
        width: "400px"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px", "label-position": "left" } },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("WriteOff.ourSideBank") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          no: "1",
                          "select-type":
                            _vm.selectTypeNames.static_data_BankAccount,
                          cache: false,
                          "default-value": _vm.ourBankAccountId,
                          "static-options": _vm.ourBankAccountArray,
                          "options-width": "450px"
                        },
                        on: { parentCallBack: _vm.getOurBankAccountFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("WriteOff.ourSideAccount") } },
                    [
                      _c("el-input", {
                        attrs: { readonly: "", no: "2" },
                        model: {
                          value: _vm.ourBankAccountNo,
                          callback: function($$v) {
                            _vm.ourBankAccountNo = $$v
                          },
                          expression: "ourBankAccountNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.editType,
                          expression: "editType"
                        }
                      ],
                      attrs: {
                        no: "3",
                        label: _vm.lbPayReceive + _vm.$t("WriteOff.method")
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          filterable: "",
                          no: "4",
                          clearable: false,
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES,
                          cache: false,
                          "default-value": _vm.receiveType || 0,
                          "static-options": _vm.receiveTypeArray
                        },
                        on: { parentCallBack: _vm.getReceiveTypesFromChild }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("WriteOff.proofNo") || "" } },
                    [
                      _c("el-input", {
                        attrs: { no: "5", maxlength: 16 },
                        model: {
                          value: _vm.form.voucherNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "voucherNo", $$v)
                          },
                          expression: "form.voucherNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_CollectionPaymentDate")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          no: "6",
                          clearable: false,
                          editable: false,
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.form.payReceiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "payReceiveDate", $$v)
                          },
                          expression: "form.payReceiveDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("WriteOff.writeOffRemarks") || "" }
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea", no: "7", maxlength: 800 },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showTicketNo,
                          expression: "showTicketNo"
                        }
                      ],
                      attrs: { label: _vm.$t("Payment.ticketNo") || "" }
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text", no: "8", maxlength: 30 },
                        model: {
                          value: _vm.form.ticketNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ticketNo", $$v)
                          },
                          expression: "form.ticketNo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "8" },
              on: { click: _vm.commitHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
          ),
          _c(
            "el-button",
            { attrs: { no: "9" }, on: { click: _vm.closeHandler } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }